import { NgModule } from '@angular/core';
import { ReplaceWithLinksDirective } from './replace-with-links.directive';

@NgModule({
    declarations: [ReplaceWithLinksDirective],
    exports: [ReplaceWithLinksDirective],
})
export class FiReplaceWithLinksModule {}
